import React from 'react';
import { Check } from 'lucide-react';
import { packages } from '../mock';

const Packages = () => {
  return (
    <section id="web-design" className="bg-[#4A5760] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-block px-10 py-3 rounded-full border border-white/30 mb-6">
            <span className="text-white tracking-[0.3em] text-sm font-medium">WEBSITES</span>
          </div>
          <h2 className="text-white text-3xl md:text-5xl font-extrabold tracking-tight">
            WEBSITE DESIGN &amp; DEVELOPMENT PACKAGES
          </h2>
          <div className="w-full max-w-5xl mx-auto h-px bg-white/20 mt-8" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className="bg-[#2C5F66] rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="bg-white p-6 flex items-center justify-center h-48">
                <img src={pkg.image} alt={pkg.title} className="max-h-36 object-contain" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-white text-xl font-bold mb-3 leading-tight">{pkg.title}</h3>
                <p className="text-white/80 text-sm mb-5 leading-relaxed">{pkg.description}</p>
                <ul className="space-y-2 mb-6 flex-1">
                  {pkg.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-white/90 text-sm">
                      <Check size={16} className="text-[#D9A04A] flex-shrink-0 mt-0.5" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#"
                  className="mt-auto inline-block text-center bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold py-3 rounded-md transition-colors"
                >
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
